/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dispatch, SetStateAction } from 'react';
import OpacityAnimation from '../../../../../components/OpacityAnimation';
import Pagination from '../../../../../components/Pagination';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import { Header } from './styles';

interface ListHeaderInterface {
  doesListExists: boolean;
  filteredListLength: number;
  singularLabel: string;
  pluralLabel: string;
  pagesQuantity: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  searchLabel: string;
  isSelectingConsults: boolean,
  setIsSelectingConsults: Dispatch<SetStateAction<boolean>>,
  clearAllSelectedConsults: () => void;
  addAllSelectedConsults: () => void;
  setActionModalShow: Dispatch<SetStateAction<boolean>>;
  isSomeConsultSelected: boolean;
  isFileSearch: boolean;
  setRemoveFileModalShow: Dispatch<SetStateAction<boolean>>;
  hasOpenedRequest: boolean;
  setSendEmailsModalShow: Dispatch<SetStateAction<boolean>>;
  selectedType: 'preAdm' | 'base';
}

export default function ListHeader({
  doesListExists,
  filteredListLength,
  singularLabel,
  pluralLabel,
  pagesQuantity,
  currentPage,
  onPageChange,
  searchLabel,
  isSelectingConsults,
  setIsSelectingConsults,
  clearAllSelectedConsults,
  addAllSelectedConsults,
  setActionModalShow,
  isSomeConsultSelected,
  setRemoveFileModalShow,
  isFileSearch,
  hasOpenedRequest,
  setSendEmailsModalShow,
  selectedType
}: ListHeaderInterface) {
  const { permissions, isCustomer } = useGetGeneralAppData();
  const routingFilePermissions = permissions.find((x) => x.codPag === 7);

  return (
    <OpacityAnimation delay={0.1}>
      <Header doesListExists={doesListExists}>
        <div className="leftAlignment">
          <strong>
            {filteredListLength || 0}
            {' '}
            {filteredListLength === 1 ? singularLabel : pluralLabel}
            {' '}
            {(isFileSearch && !filteredListLength) && 'Processamento não iniciado'}
          </strong>
          <div>
            {searchLabel}
          </div>
          {doesListExists && (
            <Pagination
              pagesQuantity={pagesQuantity}
              handlePageChange={onPageChange}
              currentPage={currentPage}
            />
          )}
        </div>
        <div className="actionButtons">
          {isSelectingConsults ? (
            <>
              <button type="button" onClick={() => {
                setIsSelectingConsults(false);
                clearAllSelectedConsults();
              }}>
                Cancelar
              </button>
              <button type="button" onClick={() => addAllSelectedConsults()}>
                Selecionar Todas
              </button>
              <button type="button" onClick={() => clearAllSelectedConsults()}>
                Desmarcar Todas
              </button>
              <button type="button" onClick={() => setActionModalShow(true)} disabled={!isSomeConsultSelected}>
                Ações (Selecionadas)
              </button>
            </>
          ) : (
            <>
              {doesListExists && (
                <button type="button" onClick={() => setIsSelectingConsults(true)}>
                Selecionar Consultas
                </button>
              )}
              {(isFileSearch && (routingFilePermissions?.incluir || !isCustomer)) && (
                <>
                  {/* {selectedType === 'preAdm' && (
                    <button type="button" onClick={() => setSendEmailsModalShow(true)}>
                    Enviar E-mails
                    </button>
                  )} */}
                  <button type="button" onClick={() => setRemoveFileModalShow(true)} disabled={hasOpenedRequest}>
                  Remover Arquivo
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </Header>
    </OpacityAnimation>
  );
}
